module.exports = __webpack_public_path__ + "static/media/Ethiopia.8ab540db.png";